import { css } from '@emotion/react';

export const styles = {
    container: css({
        width: '100%',
    }),
    inputWrapper: css({
        display: 'flex',
        flexDirection: 'row',
        gap: '5px',
        alignItems: 'flex-start',
    }),
    select: css({
        '.MuiSelect-select': {
            display: 'flex',
            alignItems: 'center',

            '.phone-input__country-name': {
                display: 'none',
            },
        },
    }),
    input: css({
        '.MuiFormHelperText-root': {
            color: 'red',
        },
        input: {
            padding: '10px 0',
            flexGrow: 1,
        },
    }),

    optionText: css({
        marginLeft: '16px',
    }),
};
